import { TranslateLoader } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of, catchError, map } from 'rxjs';

export class ApiTranslationLoader implements TranslateLoader {
  private static readonly memoryCache = new Map<string, Record<string, unknown>>();

  static clearMemoryCache(): void {
    ApiTranslationLoader.memoryCache.clear();
  }

  constructor(private readonly http: HttpClient, private readonly baseUrl: string) {}

  getTranslation(lang: string): Observable<any> {
    const cachedInMemory = ApiTranslationLoader.memoryCache.get(lang);
    if (cachedInMemory) {
      return of(cachedInMemory);
    }

    const storageKey = `translations_${lang}`;
    const cached = localStorage.getItem(storageKey);
    if (cached) {
      try {
        const parsed = JSON.parse(cached);
        if (parsed && typeof parsed === 'object') {
          ApiTranslationLoader.memoryCache.set(lang, parsed);
          return of(parsed);
        }
      } catch {
        localStorage.removeItem(storageKey);
      }
    }

    return this.http.get(`${this.baseUrl}/assets/i18n/${lang}.json`).pipe(
      map((response: any) => {
        const translations = response?.translations ?? response;

        if (translations && typeof translations === 'object') {
          ApiTranslationLoader.memoryCache.set(lang, translations);
          localStorage.setItem(storageKey, JSON.stringify(translations));
        }

        return translations;
      }),
      catchError(() => {
        console.error(`[i18n] Nenhuma tradução encontrada para ${lang}`);
        return of({});
      })
    );
  }
}
